import axiosInstance from './axiosInstance';

const getKriptonianDetails = (kriptonianId) =>
  axiosInstance.get(`/internal/admin/kriptonian/k2ps/${kriptonianId}`);

export default getKriptonianDetails;
